import { Injectable } from '@angular/core';

import { ChartFormatModel } from './typings/chart-format';
import { SessionService }   from '../../../sessions/session.service';

const MILLION  : number = 1000000;
const THOUSAND : number = 1000;

// Number formatting for chart values: full for readouts, compact for axes, rounded for headlines
@Injectable({
  providedIn: 'root'
})
export class ChartFormatService {
  constructor (
    private sessionService: SessionService
  ) {}

  // axis ticks: counts as they are, money compacted to k and M
  axis ( value : number, format : ChartFormatModel ) : string {
    if ( format === 'count' ) {
      return this.count(value);
    }

    const absolute = Math.abs(value || 0);

    if ( absolute >= MILLION ) {
      return `${ this.symbol() }${ ( value / MILLION ).toFixed(1) }M`;
    }

    if ( absolute >= THOUSAND ) {
      return `${ this.symbol() }${ ( value / THOUSAND ).toFixed(1) }k`;
    }

    return `${ this.symbol() }${ Math.round(value || 0) }`;
  }

  count ( value : number ) : string {
    return ( value || 0 ).toLocaleString();
  }

  // headline figures drop the cents
  headline ( value : number, format : ChartFormatModel ) : string {
    return format === 'count'
      ? this.count(value)
      : `${ this.symbol() }${ Math.round(value || 0).toLocaleString() }`;
  }

  symbol () : string {
    const session = this.sessionService.base();

    return ( session.country_settings && session.country_settings.currency ) || '$';
  }

  value ( value : number, format : ChartFormatModel ) : string {
    if ( format === 'count' ) {
      return this.count(value);
    }

    const amount = ( value || 0 ).toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });

    return `${ this.symbol() }${ amount }`;
  }
}
